
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';
// 公共方法
import {PRODUCT_DETAILS_FIELDKEY, YMS_MERCHANT_CONFIG_KEY_MAP} from "@/utils/enum";
import {commonLocalStorage, isJSON} from "@/utils/common";

export default {
  data() {
    return {
      deliveryIntervalList: [
        {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000165')},
        {value: 2, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000166')},
        {value: 3, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000167')},
        {value: 4, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000168')},
        {value: 5, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000169')},
        {value: 6, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000170')},
        {value: 7, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000171')}
      ], // 发货时效的数据
      productTypeListValue: ["01"],
      isInitiallyShelvedCustomizedProduct: false
    };
  },
  computed: {
    /**
     * @description 判断当前选中的属性值是否大于一个（属性值比例展示条件）
     * @returns {Boolean}
     */
    proportionTalg() {
      let talg = false;
      if (this.proportionList.length > 0) {
        talg = this.proportionList.some((item) => {
          return item.proportionValueList.length > 1;
        });
      } else {
        talg = false;
      }
      return talg;
    },
    /**
     * @description 判断当前页面是否在iframe中嵌入
     * @returns {Boolean}
     */
    isIframe() {
      return this.$route.path === "/productDetailsByExternal";
    },
    /**
     * @description 获取当前登录用户的信息
     * @returns {Object|String}
     */
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    /**
     * @description 判断是否为已上架的定制商品
     * @returns {Boolean}
     */
    alreadyShelvedCustomizedProducts() {
      return this.isInitiallyShelvedCustomizedProduct;
    },
    /**
     * @description 获取商品默认原产地国编码
     * @returns {String|undefined}
     */
    defaultOriginOfTheProduct() {
      const obj = commonLocalStorage.getItem('supplierConfigurationItemInfo') ?? this.$store.state.supplierConfigurationItemInfo;
      return obj?.productDefaultOriginalCountryCode;
    },
    /**
     * @description 判断是否启用POD工厂配置
     * @returns {Boolean}
     */
    merchantConfigurationFactory() {
      const obj = commonLocalStorage.getItem('supplierConfigurationItemInfo') ?? this.$store.state.supplierConfigurationItemInfo;
      return obj?.productGoodsFactory === 'Y';
    },
    /**
     * @description 是否展示售卖国设置
     * @returns {Boolean}
     */
    showProductSaleCountrySet() {
      const obj = commonLocalStorage.getItem('configurationItemInfo') ?? this.$store.state.configurationItemInfo;
      return Number(obj?.enableProductSaleCountrySet) === 1;
    },
    /**
     * @description 是否启用批发模式
     * @returns {Boolean}
     */
    showProductWholesaleModel() {
      const obj = commonLocalStorage.getItem('saasConfigurationItems') ?? this.$store.state.saasConfigurationItems;
      return Number(obj?.productWholesaleModelSaas) === 1;
    }
  },
  methods: {
    /**
     * @description 初始化已上架定制商品快照（加载详情时调用，避免表单切换后误判）
     * @param {Object} data - 商品详情数据
     */
    initShelvedCustomizedProductSnapshot(data) {
      this.isInitiallyShelvedCustomizedProduct = data?.isSupportCustomization === 1 && data?.shelveStatus === 1;
    },
    /**
     * @Description: 渲染表头"相同"操作区域
     * @param {Function} h - render函数的h
     * @param {Object} options - 配置项
     * @param {Object} options.column - 当前列对象
     * @param {String} options.title - 表头标题
     * @param {Array} options.data - 当前列对应的数据源
     * @param {String} options.key - 字段key，如 weight / packageDimensions
     * @param {Boolean} options.readOnly - 是否只读模式（只展示标题/提示，不展示checkbox）
     * @param {Boolean} options.required - 是否必填
     * @param {String} options.tipContent - 提示文案
     * @param {Boolean} options.showSettings - 是否显示设置图标
     * @returns {VNode}
     */
    renderCheckIdenticalHeader(h, options = {}) {
      const v = this;
      const {
        column = {},
        title = '',
        data = [],
        key = '',
        readOnly = false,
        required = false,
        tipContent = '',
        showSettings = false
      } = options;
      
      // 初始化字段，避免响应式异常
      if (column.checkIdentical === undefined) {
        if (this.$set) {
          this.$set(column, 'checkIdentical', false);
        } else {
          column.checkIdentical = false;
        }
      }
      
      const children = [
        // 标题
        h('p', {class: required ? 'required' : ''}, title)
      ];
      
      // 相同勾选框
      if (!readOnly) {
        children.push(
          h('Checkbox', {
            style: {
              marginLeft: '12px',
              display: v.isDisabled ? 'none' : 'inline-block'
            },
            props: {
              value: column.checkIdentical
            },
            on: {
              'on-change': (value) => {
                v.handleCheckIdenticalChange({value, key, data, showSettings});
              }
            }
          }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000182'))
        );
      }
      
      // 设置图标
      if (showSettings && !v.isDisabled) {
        children.push(
          h('Icon', {
            props: {
              type: 'md-settings',
              size: 20,
              color: '#2D8CF0'
            },
            class: 'cursor',
            style: {
              marginLeft: '8px'
            },
            on: {
              click: () => {
                if (v.$refs['batchFillConfiguration']) {
                  v.$refs['batchFillConfiguration'].initFillConfigurationData(key);
                }
              }
            }
          })
        );
      }
      
      // 提示图标
      if (readOnly && tipContent) {
        children.push(
          h('Tooltip', {
              props: {
                transfer: true,
                maxWidth: 350,
                content: tipContent
              },
              style: {
                marginLeft: '5px'
              }
            },
            [
              h("Icon", {
                props: {
                  type: 'md-help-circle',
                  size: 20
                },
                style: {
                  cursor: "pointer",
                  color: "#2D8CF0"
                }
              })
            ])
        );
      }
      return h('div', {
        style: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          lineHeight: '22px'
        }
      }, children);
    },
    
    /**
     * @Description: 处理"相同"勾选后的逻辑
     * @author: jing
     * @date: 2026/04/14
     * @param {Object} options
     * @param {Boolean} options.value - checkbox勾选值
     * @param {String} options.key - 当前字段key
     * @param {Array} options.data - 当前数据源
     * @param {Boolean} options.showSettings - 是否启用配置逻辑
     */
    handleCheckIdenticalChange(options = {}) {
      const {value = false, key = '', data = [], showSettings = false} = options;
      if (!value) return;
      // 未启用设置功能，直接走默认"相同"逻辑
      if (!showSettings) {
        this.setTheSameAttributeValueFun(data, key);
        return;
      }
      // 没有配置项时，走默认逻辑
      if (!Array.isArray(this.fillConfig) || this.fillConfig.length === 0) {
        this.setTheSameAttributeValueFun(data, key);
        return;
      }
      const targetConfig = this.getFillConfigByKey(key);
      // 找不到配置，走默认逻辑
      if (!targetConfig) {
        this.setTheSameAttributeValueFun(data, key);
        return;
      }
      const {fillModeType, specificationsValue} = targetConfig;
      // sku配置：按原相同逻辑赋值
      if (fillModeType === 'skuConfig') {
        this.setTheSameAttributeValueFun(data, key);
        return;
      }
      // 其他配置：按配置值批量填充
      this.setSpecificationsValueFun(specificationsValue, data, key);
    },
    
    /**
     * @Description: 根据业务字段key获取对应的批量填充配置
     * @author: jing
     * @date: 2026/04/14
     * @param {String} key - 业务字段key
     * @returns {Object|null}
     */
    getFillConfigByKey(key = '') {
      const paramKey = YMS_MERCHANT_CONFIG_KEY_MAP[key];
      if (!paramKey || !Array.isArray(this.fillConfig)) {
        return null;
      }
      return this.fillConfig.find(item => item.paramKey === paramKey) || null;
    },
    
    // 处理按照规格sku配置处理数据
    setSpecificationsValueFun(specificationsValue, data, key) {
      let valueList = [];
      this.specification.forEach((item) => {
        if (item.label === specificationsValue) {
          (item.valueList || []).forEach((ele) => {
            valueList.push(ele.label + ':' + ele.value);
          });
        }
      });
      let result = {};
      valueList.forEach(val => {
        result[val] = (data || []).filter(item => {
          return item.specificationValueId.includes(val);
        });
      });
      if (Object.keys(result).length > 0) {
        for (let k in result) {
          let newList = result[k];
          this.setTheSameAttributeValueFun(newList, key);
        }
      }
    },
    /**
     * @Description: 根据业务key获取真实字段列表（统一入口）
     * @param {String|Array} key
     * @returns {Array}
     */
    getRealKeysByBusinessKey(key) {
      if (Array.isArray(key)) return key;
      return PRODUCT_DETAILS_FIELDKEY[key] || [key];
    },
    
    /**
     * @Description: 获取第一条有效数据（作为批量赋值源）
     * @param {Array} data
     * @param {Array} keys
     * @returns {Object|null}
     */
    getFirstValidSourceItem(data = [], keys = []) {
      if (!Array.isArray(data) || data.length === 0) return null;
      const isMultiField = keys.length > 1;
      return data.find(item => {
        if (!item) return false;
        if (isMultiField) {
          return keys.some(k => item[k] !== undefined && item[k] !== null && item[k] !== '');
        }
        const field = keys[0];
        return item[field] !== undefined && item[field] !== null && item[field] !== '';
      }) || data[0];
    },
    
    /**
     * @Description: 一键设置相同的商品属性值
     * @param {Array} data
     * @param {String|Array} key
     */
    setTheSameAttributeValueFun(data = [], key = '') {
      const v = this;
      if (!Array.isArray(data) || data.length === 0 || !key) return;
      // 统一获取真实字段
      const realKeys = v.getRealKeysByBusinessKey(key);
      const isMultiField = realKeys.length > 1;
      // 获取源数据
      const sourceItem = v.getFirstValidSourceItem(data, realKeys);
      if (!sourceItem) return;
      data.forEach((item, index) => {
        // 特殊逻辑：存在相同的部位才能添加相同的数据
        if (key === 'partAndMeatSetting') {
          const sourceExtendList = (((sourceItem || {}).ingredientsObj || {}).productGoodsExtendList) || [];
          const currentExtendList = (((item || {}).ingredientsObj || {}).productGoodsExtendList) || [];
          const sourcePartNameList = sourceExtendList.map(ele => ele.partName).filter(Boolean);
          const hasSamePart = currentExtendList.some(ele => sourcePartNameList.includes(ele.partName));
          if (hasSamePart) {
            v.$set(data[index], 'partAndMeatSetting', sourceItem.partAndMeatSetting);
          }
          return;
        }
        // 多字段逻辑，例如 packageDimensions => length/width/height
        if (isMultiField) {
          realKeys.forEach(field => {
            v.$set(data[index], field, sourceItem[field]);
          });
          return;
        }
        // 普通单字段逻辑
        const field = realKeys[0];
        v.$set(data[index], field, sourceItem[field]);
      });
      v.$forceUpdate();
    },
    
    trim(string) {
      if (string) {
        string = string.replace(/(^\s*)|(\s*$)/g, "");
      }
      return string;
    },
    
    /**
     * @description 尺码表滚动到右侧
     */
    sizeTableScrollLeft() {
      let dom = document.querySelector(".sizeChartTable .ivu-table-overflowX");
      if (dom) {
        dom.scrollLeft = 99999;
      }
    },
    
    /**
     * @description 路由query参数初始化（operationType、platformProductId、productId等）
     */
    queryInit() {
      let query = this.$route.query;
      if (query) {
        const {productId, title, type, platformId} = query;
        this.operationType = type;
        if (this.isIframe) {
          this.operationType = productId ? "edit" : "add";
          this.platformProductId = platformId;
          if (this.operationType === "add" && title) {
            this.productInfo["name_zh-CN"] = title;
          }
        }
        this.productId = productId;
      }
    },
    
    /**
     * @description 向父窗口发送postMessage消息（iframe场景）
     * @param {Object} obj - 消息对象
     */
    postMessage(obj) {
      window.parent.postMessage(obj, "*");
    },
    
    /**
     * @description Select组件点击时的异常处理（修复下拉框不展开问题）
     * @param {String} refName - Select组件的ref名称
     */
    onSelectClickErrorHandel(refName) {
      let v = this;
      if (v.operationType !== "look") {
        let _show = [];
        _show.push(this.$refs[refName][0].visible);
        setTimeout(() => {
          _show.push(this.$refs[refName][0].visible);
          if (!_show[0] && !_show[1]) {
            this.$refs[refName][0].visible = true;
          }
        }, 256);
      }
    },
    
    /**
     * @description 处理商品标题多语种数据（JSON格式或纯字符串）
     * @param {Object} data - 商品详情数据，包含name字段
     */
    handleProductTitle(data) {
      let v = this;
      let names = data.name || "";
      if (names) {
        if (isJSON(names)) {
          let obj = JSON.parse(names);
          for (let key in obj) {
            v.productInfo["name_" + key] = obj[key];
          }
        } else {
          v.productInfo["name_zh-CN"] = names;
        }
      }
    },
    
    /**
     * @description 处理规格明细数据入口（设置表头 → 笛卡尔乘积 → 设置数据）
     * @param {Array} data - 规格值列表
     * @param {Number} [specIndex] - 规格索引
     * @param {String} [selectValue] - 选中的值
     */
    handleProductGoodData(data, specIndex, selectValue) {
      // 设置表头
      this.setProductGoodColumn().then(() => {
        // 笛卡尔乘积
        this.calcDescartes(data).then((cartesian) => {
          this.setProductGoodData(cartesian, specIndex, selectValue);
        });
      });
    },
    
    /**
     * @description 自定义属性值创建处理（关联属性排序）
     * @param {String|Array} value - 创建的属性值
     * @param {Number} attrIndex - 属性索引
     */
    allowCreateAttrHandel(value, attrIndex) {
      if (this.typeOf(value) === "array" && value.length > 5) {
        this.$Message.info(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000172'));
        let len = this.ymsCategoryProductAttributeList[attrIndex].propertyValues.length;
        this.ymsCategoryProductAttributeList[attrIndex].propertyValues.splice(5, len - 5);
        return;
      }
      this.ymsCategoryProductAttributeList[attrIndex].ymsProductAttributeTemplate.productAttributeDictionaryBos.push({
        cnValue: value,
        ymsProductAttributeDictionaryId: value,
        type: 0
      });
      this.getProportionData(this.ymsCategoryProductAttributeList);
    },
    
    /**
     * @description 回车键选中属性规格
     * @param {Event} event - 键盘事件
     * @param {Number} attrIndex - 规格索引
     * @param {Object} specItem - 规格项对象
     */
    selectHandleEnterKey(event, attrIndex, specItem) {
      if (specItem.isAllowCustomValue) {
        this.allowCreateSpecHandel(event.target.value, attrIndex, "Enter");
      }
    },
    
    /**
     * @description 插入自定义属性值时，校验不能与可选值重复
     * @param {String} value - 输入的自定义值
     * @param {Number} attrIndex - 规格索引
     * @param {String} [type] - 触发类型，"Enter"表示回车触发
     * @returns {Boolean|undefined}
     */
    allowCreateSpecHandel(value, attrIndex, type) {
      let v = this;
      let list = v.specification[attrIndex].list.map((item) => {
        return item.value;
      });
      if (value) {
        let val = value.replace(/\s*/g, "");
        if (type === "Enter") {
          handleData(val);
        } else {
          if (!list.includes(val)) {
            handleData(val);
          } else {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000173'));
            return false;
          }
        }
      }
      
      function handleData(val) {
        v.specification[attrIndex].list.push({value: val, _show: true});
        v.addSpecToList(attrIndex, {value: val, type: 0}, v.specification[attrIndex].isMainAttribute);
      }
    },
    
    /**
     * @description 变更类目处理（获取基础属性和尺码模板，重新渲染）
     * @param {Object} data - 类目数据
     * @param {Boolean} [isSelectIngredient=false] - 是否从选择主料触发变更
     * @param {Object|null} [ingredientItem=null] - 主料数据
     */
    emitSaveCategory(data, isSelectIngredient = false, ingredientItem = null) {
      this.choseCategoryObj = data;
      this.productInfo.ymsProductCategoryId = data.ymsProductCategoryId;
      this.getBatchFillConfigurationData(data.ymsProductCategoryId);
      this.resetDataByModifyCategory();
      let _categoryId = data.ymsProductCategoryId;
      // 变更类目 获取基础属性和尺码模板
      Promise.all([this.getItemAttributesData(_categoryId)]).then(
        async (result) => {
          let productSpecificationList = ingredientItem?.productSpecificationList || [];
          let productGoodsList = ingredientItem?.productGoodsList || [];
          const list = await this.compareAndSetValues(result[0].ymsCategoryProductAttributeList, productSpecificationList);
          isSelectIngredient ? this.attributeHandel(result[0], list) : this.attributeHandel(result[0]); // 基础属性处理
          this.specificationHandel(result[0]); // 将云卖数据组装成规格属性
          if (isSelectIngredient) {
            this.compareSpecificationAndSetValues(productGoodsList, ingredientItem); //选择主料后的规格属性校验
          }
          this.handlerTemplate(result[0]); // 处理尺码表的数据
        }
      );
      this.isShowAttrMore = true;
      this.visibleAttribute(false);
    },
    
    /**
     * @description POD选择主料后，匹配规格属性，完全匹配则在规格明细中的主料赋值
     * @param {Array} ingredientList - 主料商品列表
     * @param {Object} ingredientItem - 主料信息
     */
    compareSpecificationAndSetValues(ingredientList, ingredientItem) {
      const v = this;
      _specificationToView(ingredientList);
      
      function _specificationToView(_productGoodsList) {
        let ingredientProductGoodsList = [];
        _productGoodsList.forEach((a) => {
          let productGoodsSpecifications = a.productGoodsSpecifications || [];
          productGoodsSpecifications.forEach((b) => {
            v.specification.forEach((i) => {
              let optionsList = i.attributeValueData || [];
              if (b.name === i.label && optionsList.includes(b.value)) {
                let ingredientIObj = {...ingredientItem, ...a};
                const isIncludes = ingredientProductGoodsList.find((fItem) => fItem.sku === ingredientIObj.sku);
                if (!isIncludes) {
                  ingredientProductGoodsList.push(ingredientIObj);
                }
                let disabledTalg = false;
                let disableText = "";
                let attributeTalg = i.attributeValueDeactivationData.includes(b.value) && b.type !== 0;
                if (attributeTalg) {
                  disableText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000174');
                }
                let attributeValueExceptionTalg = !i.attributeValueData.includes(b.value) && !i.isAllowCustomValue;
                if (attributeValueExceptionTalg) {
                  disableText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000175');
                }
                if (i.valueList.every((i) => i.value !== b.value)) {
                  i.list.forEach((item) => {
                    if (item.value === b.value) {
                      item._show = false;
                    }
                  });
                  // 审批通过
                  if (v.productInfo.auditStatus === 3) {
                    disabledTalg = !(attributeTalg || attributeValueExceptionTalg);
                  } else {
                    disabledTalg = false;
                  }
                  i.valueList.push({
                    value: b.value,
                    label: i.label,
                    imgList: [],
                    attributeTalg: attributeTalg, // 属性值停用状态
                    disabled: disabledTalg, // 禁用状态
                    disableText: disableText, // 异常提示文本
                    attributeValueExceptionTalg: attributeValueExceptionTalg // 属性值异常状态
                  });
                  i.valueList = v.uniqueFunc(i.valueList, "value");
                  // 属于自定义属性
                  if (!i.attributeValueData.includes(b.value) && i.isAllowCustomValue) {
                    i.list.push({
                      value: b.value,
                      _show: true,
                      attributeTalg: attributeTalg, // 属性值停用状态
                      disabled: disabledTalg,
                      disableText: disableText,
                      attributeValueExceptionTalg: attributeValueExceptionTalg
                    });
                    i.list = v.uniqueFunc(i.list, "value");
                  }
                }
              }
            });
          });
        });
        v.ingredientProductGoodsList = ingredientProductGoodsList;
        
        let arr = []; // 选中数据
        v.specification.forEach((i) => {
          if (i.valueList.length) {
            arr.push(i.valueList);
          }
        });
        v.handleProductGoodData(arr);
      }
    },
    
    /**
     * @description 比较主料与类目的商品属性，根据cnName是否相同，将主料的values赋值到商品属性
     * @param {Array} categoryList - 类目属性列表
     * @param {Array} ingredientList - 主料规格列表
     * @returns {Promise<Array>} 匹配后的属性列表
     */
    compareAndSetValues(categoryList, ingredientList) {
      return new Promise((resolve) => {
        if (!categoryList || categoryList.length === 0) resolve([]);
        let list = [];
        const map = new Map(
          categoryList.map((cItem) => {
            if (cItem.ymsProductAttributeTemplate) {
              return [
                cItem.ymsProductAttributeTemplate.cnName,
                cItem.ymsProductAttributeTemplate.ymsProductAttributeTemplateId
              ];
            }
          })
        );
        ingredientList.forEach((iItem) => {
          if (map.has(iItem.name)) {
            let obj = {
              ...iItem,
              ymsProductAttributeTemplateId: map.get(iItem.name)
            };
            list.push(obj);
          }
        });
        resolve(list);
      });
    },
    
    /**
     * @description 修改分类时重置相关数据
     */
    resetDataByModifyCategory() {
      this.productData = [];
      this.productDataSpan = [];
      this.priceInventoryDataSpan = [];
      this.priceInventoryData = [];
      this.productInfo.productGoodsList = [];
      this.ymsCategoryProductAttributeList = [];
      this.specification = [];
      this.sizeChartData = [];
      this.initMultilingualFields("productInfo", this.productInfo, ["name_"]);
    },
    
    /**
     * @description 商品属性change事件处理（含联动属性、异常属性值清除、比例数据更新）
     * @param {String|Array} value - 属性值
     * @param {Number} attrIndex - 属性索引
     * @param {Object} [obj] - 附加对象
     */
    productAttributeChange(value, attrIndex, obj) {
      if (this.changeInAttributeValues) {
        if (value && value.length > 0) {
          if (this.typeOf(value) === "array" && value.length > 5) {
            this.$Message.info(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000172'));
            let len = this.ymsCategoryProductAttributeList[attrIndex].propertyValues.length;
            this.ymsCategoryProductAttributeList[attrIndex].propertyValues.splice(5, len - 5);
          }
          this.$set(this.ymsCategoryProductAttributeList[attrIndex], "attrRequireValid", true);
        } else {
          if (this.ymsCategoryProductAttributeList[attrIndex].ymsProductAttributeTemplate.attributeRequire === 0) {
            this.$set(this.ymsCategoryProductAttributeList[attrIndex], "attrRequireValid", false);
          } else {
            this.$set(this.ymsCategoryProductAttributeList[attrIndex], "attrRequireValid", true);
          }
        }
        // 切换属性值，自动去掉异常的属性值
        if (value) {
          let obj = this.ymsCategoryProductAttributeList[attrIndex];
          if (obj.disableText) {
            if (this.typeOf(value) === "array") {
              let attributeValueData = obj.ymsProductAttributeTemplate.productAttributeDictionaryBos;
              if (attributeValueData.length > 0) {
                let newList = attributeValueData.filter((ele) => {
                  return ele.ymsProductAttributeDictionaryId === ele.cnValue;
                });
                if (obj.propertyValues.length > 0) {
                  if (newList.length > 0) {
                    newList.map((item) => {
                      if (!obj.propertyValues.includes(item.ymsProductAttributeDictionaryId)) {
                        if (item.ymsProductAttributeDictionaryId == item.cnValue) {
                          attributeValueData.map((ele, idx) => {
                            if (ele.ymsProductAttributeDictionaryId === item.cnValue) {
                              attributeValueData.splice(idx, 1);
                            }
                          });
                          obj.disableText = "";
                        }
                      }
                    });
                  }
                } else {
                  this.ymsCategoryProductAttributeList.map((item) => {
                    if (item.ymsProductAttributeTemplate.productAttributeDictionaryBos.length > 0) {
                      item.ymsProductAttributeTemplate.productAttributeDictionaryBos = item.ymsProductAttributeTemplate.productAttributeDictionaryBos.filter((ele) => {
                        return (ele.ymsProductAttributeDictionaryId !== ele.cnValue);
                      });
                    }
                  });
                  this.$set(
                    this.ymsCategoryProductAttributeList[attrIndex],
                    "disableText",
                    ""
                  );
                }
              }
            } else {
              let attributeValueData =
                obj.ymsProductAttributeTemplate.productAttributeDictionaryBos;
              if (attributeValueData.length > 0) {
                let newList = attributeValueData.filter((ele) => {
                  return ele.ymsProductAttributeDictionaryId === ele.cnValue;
                });
                if (obj.propertyValues) {
                  if (newList.length > 0) {
                    newList.map((item) => {
                      if (obj.propertyValues !== item.ymsProductAttributeDictionaryId) {
                        if (item.ymsProductAttributeDictionaryId == item.cnValue) {
                          attributeValueData.map((ele, idx) => {
                            if (ele.ymsProductAttributeDictionaryId === item.cnValue) {
                              attributeValueData.splice(idx, 1);
                            }
                          });
                          obj.disableText = "";
                        }
                      }
                    });
                  }
                } else {
                  this.ymsCategoryProductAttributeList.map((item) => {
                    if (item.ymsProductAttributeTemplate.productAttributeDictionaryBos.length > 0) {
                      item.ymsProductAttributeTemplate.productAttributeDictionaryBos = item.ymsProductAttributeTemplate.productAttributeDictionaryBos.filter((ele) => {
                          return (ele.ymsProductAttributeDictionaryId !== ele.cnValue);
                        }
                      );
                    }
                  });
                  this.$set(this.ymsCategoryProductAttributeList[attrIndex], "disableText", "");
                }
              }
            }
            this.$set(this.ymsCategoryProductAttributeList[attrIndex], "disableText", "");
          }
          this.$forceUpdate();
        }
        if (this.automaticallyTitle) {
          this.automaticallyTitleChange(true, "en-US");
        }
        // 处理联动属性
        let list = [];
        let associationProperty = this.ymsCategoryProductAttributeList[attrIndex].associationProperty;
        let ymsProductAttributeDictionaryIdList = this.ymsCategoryProductAttributeList[attrIndex].ymsProductAttributeDictionaryIdList || [];
        this.ymsCategoryProductAttributeList = this.ymsCategoryProductAttributeList.filter((item) => {
          return !ymsProductAttributeDictionaryIdList.includes(item.ymsProductAttributeTemplate.ymsProductAttributeDictionaryId);
        });
        if (associationProperty) {
          if (Array.isArray(value)) {
            list = this.associationPropertyData.filter((item) => value.includes(item.ymsProductAttributeTemplate.ymsProductAttributeDictionaryId));
          } else {
            list = this.associationPropertyData.filter((item) => item.ymsProductAttributeTemplate.ymsProductAttributeDictionaryId === value);
          }
          if (list.length > 0) {
            // 记录插入元素的唯一标识
            this.insertedListIds = list.map(item => item.ymsProductAttributeTemplate.ymsProductAttributeTemplateId);
            this.ymsCategoryProductAttributeList.splice(attrIndex + 1, 0, ...list);
            this.ymsCategoryProductAttributeList = this.uniqueFunc(this.ymsCategoryProductAttributeList, 'ymsProductAttributeTemplateId');
          } else {
            // 如果 list 为空，移除之前插入的数据
            if (this.insertedListIds && this.insertedListIds.length > 0) {
              this.ymsCategoryProductAttributeList = this.ymsCategoryProductAttributeList.filter(item => {
                return !this.insertedListIds.includes(item.ymsProductAttributeTemplate.ymsProductAttributeTemplateId);
              });
              this.insertedListIds = [];
            }
          }
        }
        this.getProportionData(this.ymsCategoryProductAttributeList);
      }
    },
    
    /**
     * @description 校验属性值比例（非空、正整数、总和100%）
     * @returns {Boolean} 是否校验通过
     */
    attributeValueRatioValidate() {
      let valid = true;
      let v = this;
      if (v.proportionList.length > 0) {
        let valueList = [];
        for (let j = 0; j < v.proportionList.length; j++) {
          let item = v.proportionList[j];
          if (item.proportionValueList.length > 0) {
            for (let i = 0; i < item.proportionValueList.length; i++) {
              let ele = item.proportionValueList[i];
              if (item.proportionValueList.length === 1) {
                ele.value = 100;
              }
              if (ele.value) {
                valueList.push(ele.value);
              } else {
                valid = false;
                v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000176'));
                return false;
              }
            }
          }
        }
        if (valueList.length > 0) {
          let reg = v.$regular.positiveInteger;
          for (let i = 0; i < valueList.length; i++) {
            let number = Number(valueList[i]);
            if (!reg.test(number)) {
              valid = false;
              v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000177'));
              return false;
            }
          }
        }
        let newList = v.proportionList.filter((item) => {
          return item.proportionValueList.length > 0;
        });
        if (newList.length > 0) {
          v.proportionList.map((item) => {
            item.totalProportion = item.proportionValueList.reduce(
              (total, ele) => {
                let value = Number(ele.value) || 0;
                return total + value;
              },
              0
            );
          });
          let talg = newList.every((item) => {
            return item.totalProportion === 100;
          });
          if (!talg) {
            valid = false;
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000178'));
            return false;
          }
        }
      }
      return valid;
    },
    
    /**
     * @description 校验规格属性是否有包含已经停用的属性值
     * @returns {Boolean} 是否校验通过
     */
    verifySpecificationAttributes() {
      let v = this;
      if (v.specification && v.specification.length > 0) {
        let newList = [];
        let talg = false;
        let abnormalTalg = false;
        v.specification.map((item) => {
          item.valueList.map((ele) => {
            newList.push(ele);
          });
        });
        let list = v.uniqueFunc(newList, "value");
        if (list.length > 0) {
          talg = list.some((ele) => ele.attributeTalg === true);
          abnormalTalg = list.some((ele) => ele.attributeValueExceptionTalg === true);
        } else {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000183'));
          return false;
        }
        if (talg) {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000179'));
          return false;
        } else if (abnormalTalg) {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000180'));
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    
    /**
     * @description 校验基础属性是否包含已经停用的属性值
     * @returns {Boolean} 是否校验通过
     */
    derifyDeactivatedAttributeValues() {
      let v = this;
      // 商品属性
      if (v.ymsCategoryProductAttributeList && v.ymsCategoryProductAttributeList.length > 0) {
        let list = v.ymsCategoryProductAttributeList.filter((item) => {
          return (
            item.disableText &&
            item.disableText !== "" &&
            item.ymsProductAttributeTemplate.attributeRequire === 0
          );
        });
        if (list.length > 0) {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000181'));
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    
    /**
     * 格式化修改前的值为可读文本，空值显示占位符 "-"
     * @param {*} val - 原始值
     * @returns {String} 格式化后的文本
     */
    _formatPreRevisionValue(val) {
      if (val === null || val === '') return '-';
      return String(val);
    },
    
    /**
     * 基础信息修改前内容（当前仅处理 deliveryInterval，switch 结构便于后续扩展）
     * @param {String} fieldKey - 字段键名
     * @param {Object} coreInfo - coreYmsProductInfo 对象
     * @returns {String|null} 有变化时返回格式化文本，无变化返回 null
     */
    _getBaseInfoPreContent(fieldKey, coreInfo) {
      switch (fieldKey) {
        case 'deliveryInterval': {
          const oldVal = coreInfo.deliveryInterval;
          if (oldVal === this.productInfo.deliveryInterval) return null;
          const item = (this.deliveryIntervalList || []).find(d => d.value === oldVal);
          return this._formatPreRevisionValue(item ? item.name : oldVal);
        }
        default:
          return null;
      }
    },
    
    /**
     * 基础属性修改前内容
     * @param {String} templateId - ymsProductAttributeTemplateId
     * @param {Object} coreInfo - coreYmsProductInfo 对象
     * @returns {String|null} 有变化时返回格式化文本，无变化返回 null
     */
    _getBasicAttributePreContent(templateId, coreInfo) {
      const oldAttrList = coreInfo.productAttributeResultList || [];
      const oldAttr = oldAttrList.find(a => a.ymsProductAttributeTemplateId === templateId);
      if (!oldAttr) return null;
      
      // 当前属性模板对象
      const currentAttr = (this.ymsCategoryProductAttributeList || []).find(
        a => a.ymsProductAttributeTemplateId === templateId
      );
      if (!currentAttr) return null;
      
      const template = currentAttr.ymsProductAttributeTemplate || {};
      const dictList = template.productAttributeDictionaryBos || [];
      const type = template.type; // 0 自定义, 1 可选值
      
      // 自定义类型
      if (type === 0) {
        const oldValues = oldAttr.values || [];
        const oldVal = oldValues.length > 0 ? oldValues[0].value : null;
        if (oldVal === currentAttr.propertyValues) return null;
        return this._formatPreRevisionValue(oldVal);
      }
      
      // 可选值类型
      const oldValues = oldAttr.values || [];
      
      // 将旧值的 ID 映射到可读文本
      const oldTextList = oldValues.map(v => {
        const dictItem = dictList.find(d => d.ymsProductAttributeDictionaryId === v.value);
        return dictItem ? dictItem.cnValue : v.value;
      }).filter(Boolean);
      
      // 与当前值比较
      const currentValues = Array.isArray(currentAttr.propertyValues)
        ? currentAttr.propertyValues
        : (currentAttr.propertyValues ? [currentAttr.propertyValues] : []);
      const currentTextList = currentValues.map(val => {
        const dictItem = dictList.find(d => d.ymsProductAttributeDictionaryId === val);
        return dictItem ? dictItem.cnValue : val;
      }).filter(Boolean);
      
      const oldStr = oldTextList.join('、');
      const currentStr = currentTextList.join('、');
      if (oldStr === currentStr) return null;
      return this._formatPreRevisionValue(oldStr);
    },
    
    /**
     * 供货价修改前内容
     * @param {Object} rowIdentifier - row 行数据的标识字段对象，包含 supplierProductGoodsId/ymsProductGoodsId/supplierSku/ymsSku
     * @param {Object} coreInfo - coreYmsProductInfo 对象
     * @param {Object} extra - 额外参数，需包含 countryCode
     * @returns {String|null} 有变化时返回格式化文本，无变化返回 null
     */
    _getSupplyPricePreContent(rowIdentifier, coreInfo, extra) {
      if (!rowIdentifier || !extra || !extra.countryCode) return null;
      const oldGoodsList = coreInfo.productGoodsList || [];
      // 通过 row 传入的多个标识字段匹配旧商品数据
      const oldGoods = oldGoodsList.find(g =>
        (rowIdentifier.supplierProductGoodsId && g.supplierProductGoodsId === rowIdentifier.supplierProductGoodsId) ||
        (rowIdentifier.ymsProductGoodsId && g.ymsProductGoodsId === rowIdentifier.ymsProductGoodsId) ||
        (rowIdentifier.supplierSku && g.supplierSku === rowIdentifier.supplierSku) ||
        (rowIdentifier.ymsSku && g.ymsSku === rowIdentifier.ymsSku)
      );
      if (!oldGoods) return null;
      
      // ymsProductGoodsPrices 可能为 null，此时表示修改前无供货价数据
      const oldPrices = oldGoods.ymsProductGoodsPrices || [];
      const oldPriceObj = oldPrices.find(p => p.countryCode === extra.countryCode);
      const oldPrice = oldPriceObj ? oldPriceObj.supplyPrice : null;
      
      // 与当前值比较
      const priceKey = `${extra.countryCode}_supplyPrice`;
      const currentIndex = (this.priceInventoryData || []).findIndex(d =>
        (d.supplierProductGoodsId && d.supplierProductGoodsId === oldGoods.supplierProductGoodsId) ||
        (d.ymsProductGoodsId && d.ymsProductGoodsId === oldGoods.ymsProductGoodsId) ||
        (d.supplierSku && d.supplierSku === oldGoods.supplierSku)
      );
      const currentPrice = currentIndex > -1 ? this.priceInventoryData[currentIndex][priceKey] : undefined;
      
      // 新旧值相同则不展示
      if (oldPrice != null && currentPrice != null && Number(currentPrice) === Number(oldPrice)) return null;
      if (oldPrice == null && (currentPrice == null || currentPrice === undefined)) return null;
      
      return this._formatPreRevisionValue(oldPrice);
    }
  }
};
